export const FETCH_COMBINED_MODES_LOADING = 'FETCH_COMBINED_MODES_LOADING';
export const FETCH_COMBINED_MODES_SUCCESS = 'FETCH_COMBINED_MODES_SUCCESS';
export const FETCH_COMBINED_MODES_FAILURE = 'FETCH_COMBINED_MODES_FAILURE'; 

export const FETCH_GLOBAL_WORK_MODES_LOADING = 'FETCH_GLOBAL_WORK_MODES_LOADING';
export const FETCH_GLOBAL_WORK_MODES_SUCCESS = 'FETCH_GLOBAL_WORK_MODES_SUCCESS';
export const FETCH_GLOBAL_WORK_MODES_FAILURE = 'FETCH_GLOBAL_WORK_MODES_FAILURE';